import { h } from 'vue';
import { ClipboardIcon, WhatsappIcon } from '@hugeicons/core-free-icons';
import HugeIcon from 'dashboard/components-next/icon/HugeIcon.vue';

const hugeIcon = icon =>
  h(HugeIcon, {
    icon,
    size: 20,
    class: 'shrink-0',
  });

/**
 * Lucide icons aligned with `useSettingsNavConfig` sidebar entries.
 * Keys are Vue Router route `name` values used under workspace settings (and related flows).
 */
export const SETTINGS_ROUTE_TITLE_ICON = {
  // Security (sidebar: shield)
  security_settings_index: 'i-lucide-shield',

  // Users & teams (sidebar user-role section)
  agent_list: 'i-lucide-square-user',
  settings_teams_list: 'i-lucide-users',
  settings_teams_new: 'i-lucide-users',
  settings_teams_finish: 'i-lucide-users',
  settings_teams_add_agents: 'i-lucide-users',
  settings_teams_edit: 'i-lucide-users',
  settings_teams_edit_members: 'i-lucide-users',
  settings_teams_edit_finish: 'i-lucide-users',
  settings_teams_show: 'i-lucide-users',

  // Agent assignment (sidebar: user-cog)
  assignment_policy_index: 'i-lucide-user-cog',
  agent_assignment_policy_index: 'i-lucide-user-cog',
  agent_assignment_policy_create: 'i-lucide-user-cog',
  agent_assignment_policy_edit: 'i-lucide-user-cog',
  agent_capacity_policy_index: 'i-lucide-user-cog',
  agent_capacity_policy_create: 'i-lucide-user-cog',
  agent_capacity_policy_edit: 'i-lucide-user-cog',

  // Channels / inboxes (sidebar: square-stack)
  settings_inbox_list: hugeIcon(ClipboardIcon),
  settings_inbox_show: hugeIcon(ClipboardIcon),
  settings_inbox_new: hugeIcon(ClipboardIcon),
  settings_inbox_finish: hugeIcon(ClipboardIcon),
  settings_inboxes_page_channel: hugeIcon(ClipboardIcon),

  // Integrations hub (sidebar: blocks)
  settings_applications: 'i-lucide-blocks',
  settings_integrations_dashboard_apps: 'i-lucide-blocks',
  settings_integrations_webhook: 'i-lucide-blocks',
  settings_integrations_slack: 'i-lucide-blocks',
  settings_integrations_linear: 'i-lucide-blocks',
  settings_integrations_notion: 'i-lucide-blocks',
  settings_integrations_shopify: 'i-lucide-blocks',
  settings_applications_integration: 'i-lucide-blocks',

  // Contact & conversation attributes (sidebar)
  attributes_list: 'i-lucide-contact',
  contact_fields_list: 'i-lucide-contact',
  conversation_fields_list: 'i-lucide-message-square-text',

  general_info_index: 'i-lucide-info',

  lifecycle_stages_list: 'i-lucide-refresh-cw',
  lifecycle_stages_wrapper: 'i-lucide-refresh-cw',

  conversation_workflow_index: 'i-lucide-file-text',

  labels_list: 'i-lucide-tags',
  labels_wrapper: 'i-lucide-tags',

  canned_list: 'i-lucide-message-square-quote',

  captain_settings_index: 'i-lucide-bot',

  captain_assistants_index: 'i-lucide-sparkles',
  captain_assistants_create_index: 'i-lucide-sparkles',
  captain_assistants_responses_index: 'i-lucide-sparkles',
  captain_assistants_documents_index: 'i-lucide-sparkles',
  captain_assistants_scenarios_index: 'i-lucide-sparkles',
  captain_assistants_playground_index: 'i-lucide-sparkles',
  captain_assistants_inboxes_index: 'i-lucide-sparkles',
  captain_assistants_responses_pending: 'i-lucide-sparkles',
  captain_assistants_settings_index: 'i-lucide-sparkles',
  captain_assistants_guardrails_index: 'i-lucide-sparkles',
  captain_assistants_guidelines_index: 'i-lucide-sparkles',

  ai_agents: 'i-lucide-bot-message-square',
  ai_agents_templates: 'i-lucide-layout-template',
  ai_agents_template_preview: 'i-lucide-layout-template',
  ai_agents_new: 'i-lucide-bot-message-square',
  ai_agents_edit: 'i-lucide-bot-message-square',

  ai_assist_settings: 'i-lucide-message-circle',
  ai_knowledge_sources_settings: 'i-lucide-book-open',
  ai_prompts_settings: 'i-lucide-zap',

  macros_wrapper: 'i-lucide-toy-brick',
  macros_edit: 'i-lucide-toy-brick',
  macros_new: 'i-lucide-toy-brick',

  agent_bots: 'i-lucide-bot',

  automation_list: 'i-lucide-repeat',
  automation_editor_new: 'i-lucide-repeat',
  automation_editor_edit: 'i-lucide-repeat',

  auditlogs_list: 'i-lucide-briefcase',

  custom_roles_list: 'i-lucide-shield-plus',

  sla_list: 'i-lucide-clock-alert',
  sla_wrapper: 'i-lucide-clock-alert',

  // Billing (main settings rail)
  general_settings_whatsapp_fees: hugeIcon(WhatsappIcon),
  general_settings_billing: 'i-lucide-credit-card',
  general_settings_billing_plans: 'i-lucide-layout-grid',
  general_settings_ai_billing: 'i-lucide-sparkles',

  profile_settings: 'i-lucide-user-circle',
  profile_settings_index: 'i-lucide-user-circle',
  profile_settings_notifications: 'i-lucide-bell',
  profile_settings_mfa: 'i-lucide-fingerprint',

  // Reports: main sidebar uses chart-spline for the Reports section
  account_overview_reports: 'i-lucide-chart-spline',
  conversation_reports: 'i-lucide-chart-spline',
  sla_reports: 'i-lucide-chart-spline',
  csat_reports: 'i-lucide-chart-spline',
  bot_reports: 'i-lucide-chart-spline',
  agent_reports_index: 'i-lucide-chart-spline',
  agent_reports_show: 'i-lucide-chart-spline',
  inbox_reports_index: 'i-lucide-chart-spline',
  inbox_reports_show: 'i-lucide-chart-spline',
  team_reports_index: 'i-lucide-chart-spline',
  team_reports_show: 'i-lucide-chart-spline',
  label_reports_index: 'i-lucide-chart-spline',
  label_reports_show: 'i-lucide-chart-spline',
  agent_reports: 'i-lucide-chart-spline',
  inbox_reports: 'i-lucide-chart-spline',
  label_reports: 'i-lucide-chart-spline',
  team_reports: 'i-lucide-chart-spline',
};

const FALLBACK_ICON = 'i-lucide-settings-2';

/**
 * @param {string|symbol|undefined|null} routeName
 * @returns {string|object}
 */
export function getSettingsPageTitleIcon(routeName) {
  if (!routeName || typeof routeName !== 'string') {
    return FALLBACK_ICON;
  }
  return SETTINGS_ROUTE_TITLE_ICON[routeName] ?? FALLBACK_ICON;
}
